// Pathify
import {make} from 'vuex-pathify'
import api from '@/services/api'
import {toast} from '@/util/helpers';
import models from "../../models";

// Data
const state = {
	certificates: [],
	certificate: models.Certification('Certificate'),
}

const getters = make.getters(state)


const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getCertificates: ({dispatch}) => {
		api.certificates.index()
			.then(response => dispatch('setCertificates', response.data))
			.catch(error => {
				console.log(error);
				toast.add(error.message, 'error')
			})
	},
	getCertificate: ({dispatch}, id) => {
		api.certificates.show(id)
			.then(response => dispatch('setCertificate', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}
}


export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
